import * as R from "ramda";

const titleCase = R.compose(R.join(""), R.over(R.lensIndex(0), R.toUpper));
const removeUnderscores = s => s.replace(/_/g, " ");
const dedupeSpaces = s => s.replace(/ +/g, " ");
export const beautifyAlNum = R.compose(
  titleCase,
  dedupeSpaces,
  removeUnderscores,
  R.join(" "),
  R.groupWith(R.eqBy(s => /\d/.test(s)))
);

export const compare = new Intl.Collator(undefined, { numeric: true }).compare;

export const compareBy = fn => (a, b) => compare(fn(a), fn(b));

export const maybeNumber = string =>
  Number.isInteger(Number(string)) ? Number(string) : string;

export const pathStringToArray = R.compose(R.map(maybeNumber), R.split("."));

export const escapeRegExp = string =>
  string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string

export const toValidId = R.when(
  R.is(String),
  R.compose(
    R.replace(/_+$/, ""), // Remove trailing underscores
    R.replace(/[^a-z0-9_]/g, "_"), // Replace all non-ascii with underscore
    R.when(R.test(/^[0-9]/), R.concat("_")), // May not start with a number -> prepend an underscore
    R.toLower,
    R.trim
  )
);

export const hasDynamicPart = R.test(/\^{[A-z_][A-z0-9_]*}/);

export const linecol = (pos, code) =>
  R.compose(
    lines => {
      return [lines.length - 1, lines.pop().length];
    },
    R.split("\n"),
    R.slice(0, pos)
  )(code);

export const nameToPath = R.compose(R.path, pathStringToArray);
